import React from 'react';
import { Container, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import { WysiwygField } from '../../../components';

import './style.scss';

const IconWrapper = ({ id, entity }) => {

  const entities = entity.getIn(['field_icons']);
  const wrapperTitle = entity.getIn(['field_title', 0, 'value']);
  const wrapperBody = entity.getIn(['field_body', 0, 'processed']);

  return (
    <Container id={id} className="IconWrapper">
      {(wrapperTitle || wrapperBody) && (
        <div className="IconWrapper__info">
          {wrapperTitle && <h2>{wrapperTitle}</h2>}
          {wrapperBody && (
            <WysiwygField
              property="schema:text"
              html={wrapperBody}
            />
          )}
        </div>
      )}
      <div className="row">
        {
          entities.map((item, index) => {
            const iconSrc = item.getIn(['entity', 'field_icon', 0, 'entity', 'field_media_icon', 0, 'url']);
            const title = item.getIn(['entity', 'field_title', 0, 'value']);
            const body = item.getIn(['entity', 'field_body', 0, 'value']);
            const linkTitle = item.getIn(['entity', 'field_link', 0, 'title']);
            const linkUri = item.getIn(['entity', 'field_link', 0, 'alias'], item.getIn(['entity', 'field_link', 0, 'uri']));
            const openRedirect = item.getIn(['entity', 'field_redirect', 0, 'value'], null);

            return (
              <div key={title} className="col-sm-12 col-md-6 col-lg-4 IconWrapper__icontext">
                {(openRedirect === 'window' || openRedirect === null) && linkUri && (
                  <CoreLink to={linkUri} title={linkTitle} key={index} target="_blank" rel="noopener noreferrer">
                    <Image src={iconSrc} />
                  </CoreLink>
                )}

                {openRedirect === 'tab' && linkUri && (
                  <CoreLink to={linkUri} title={linkTitle} key={index}>
                    <Image src={iconSrc} />
                  </CoreLink>
                )}

                {!linkTitle && !linkUri && (
                  <Image src={iconSrc} />
                )}

                <h4>{title}</h4>
                <WysiwygField
                  property="schema:text"
                  html={body}
                />

                {linkTitle && linkUri && (
                  <CoreLink to={linkUri} title={linkTitle} className="inline-link">
                    {linkTitle}
                  </CoreLink>
                )}
              </div>
            );
          })
        }
      </div>
    </Container>
  );
};

export default IconWrapper;
